import { Delete, ExitToApp, NoteAdd, Print, Save } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material'
import axios from 'axios';
import React, { Fragment, memo, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers';
import { useNavigate } from 'react-router-dom';
import DialogCancel from '../../../../../components/utils/dialogCancel/dialogCancel';

const CustomerInfo = ({data, postData, setPostData , setData ,}) => {
const dispatch = useDispatch()
const navigate = useNavigate()
  const [dialogClose, setDialogClose] = useState(false);

 const totalWithRetQty = data.reduce((acc, item) => {
  if (item.retQty > 0) {
    return acc + parseFloat(item.totalAmt);
  }
  return acc;
}, 0);

const gstWithRetQty = data.reduce((acc, item) => {
  if (item.retQty > 0) {
    return acc + parseFloat(item.gst_amt);
  }
  return acc;
}, 0);

const cessWithRetQty = data.reduce((acc, item) => {
  if (item.retQty > 0) {
    return acc + parseFloat(item.cess_amt);
  }
  return acc;
}, 0);

let grandTotal= totalWithRetQty + gstWithRetQty + cessWithRetQty
const onClickCancel = () => {
  setDialogClose(false);
};
const onClickExit = () => {
  navigate("/");
};
// console.log(paymentDetails)
const handleExit = () => {
  setDialogClose(true);
};
  const Design = ({ title, value }) => (
    <div className="flex items-center">
      <Typography variant="body1" sx={{ fontWeight: 600, width: "100%" }}>
        {title}
      </Typography>
      <Typography
        variant="h6"
        textAlign="right"
        sx={{
          fontWeight: 600,
          width: "100%",
          padding: 0.5,
        }}
      >
             {parseFloat(value).toFixed(2)}
      </Typography>
    </div>
  );
  useEffect(() => {
    // amount:billNo.amount,gst_per:billNo.gst_per , gst_amt:billNo.gst_amt,cess_per:billNo.cess_per,cess_amt:billNo.cess_amt,
    setPostData((prevState)=>({...prevState,amount : parseFloat(Math.round(grandTotal).toFixed(2)),gst_amt: gstWithRetQty, cess_amt : cessWithRetQty,subtotal_amount:totalWithRetQty,roff:parseFloat(grandTotal - Math.round(grandTotal)).toFixed(2)}))
  },[data])
console.log(postData)
  function handleSubmit(){
    if(postData.billno === "" ){
      dispatch(setSnackbar(true , "error" , "Please Select Bill No"))
    }else if( grandTotal === 0){
      dispatch(setSnackbar(true , "error" , "Please entry the return qty"))
    }
    else if(postData.purchase_return_details.length > 0 && grandTotal !== 0){
      axios.post(`/v1/purchase_return`,postData)
      .then((res) => {
        setTimeout(()=>{
          window.location.reload();
        },1000)
        dispatch(setSnackbar(true ,"success" , "Bill Saved Successfully"))})
    .catch((err) => {console.log(err); dispatch(setSnackbar(true,'error',err.response.data.errors[0].message)) })
    }else{
      dispatch(setSnackbar(true , "error" , "Please Select Bill No"))
    }
  }
  const handleDelete = () =>{
   setData([])
  }
  return (
<Fragment>

<Typography
        variant="h6"
        textAlign="center"
        mb={2}
        sx={{ backgroundColor: "#83A2FF" }}
      >
        Total
      </Typography>
    <div className="flex p-1">

          <Typography
          className=' '
          textAlign="right" sx={{  paddingRight: 0.4, fontWeight: 600, fontSize: 36}}          >
           {Math.round(grandTotal).toFixed(2)}
          </Typography>
        </div>
        <div className="my-2">
      <Typography variant="h6" textAlign="center" mb={2} sx={{ backgroundColor: "#83A2FF" }} >Summary
      </Typography>
      <Design title="Sub Total" value={totalWithRetQty} />
          <Design title="GST Amt" value={gstWithRetQty}/>
          <Design title="Cess" value={cessWithRetQty}/>
          <Design title="Round Off" value={(grandTotal - Math.round(grandTotal).toFixed(2))}/>
          <Design title="Net Total" value={Math.round(grandTotal)}/>
    </div>
    <Stack  >
            {/* <Button size="small" sx={{margin:1}} startIcon={<Delete/>} variant="outlined" onClick={handleDelete} >Delete</Button> */}
            {/* <Button size="small" sx={{margin:1}} startIcon={<Print/>} variant="outlined">Print</Button> */}
            <Button size="small" sx={{margin:1}} startIcon={<NoteAdd/>} variant="outlined" onClick={()=>  window.location.reload()}>New</Button>
            <Button size="small" sx={{margin:1}} startIcon={<Save/>} variant="outlined" onClick={handleSubmit}>Save</Button>
            <Button size="small" sx={{margin:1}} startIcon={<ExitToApp />} variant="outlined" onClick={handleExit}>Exit</Button>
        </Stack>
        <DialogCancel
        onClickCancel={onClickCancel}
        onClickExit={onClickExit}
        dialogClose={dialogClose}
        setDialogClose={setDialogClose}
      />
</Fragment>
  )
}

export default memo(CustomerInfo)